class CartRecentlyViewed extends HTMLElement {
  connectedCallback() { this.load(); }
  disconnectedCallback() { this.controller?.abort(); }

  async load() {
    this.controller?.abort();
    const controller = new AbortController();
    this.controller = controller;
    let ids = [];
    let cards = [];
    try {
      const stored = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
      if (Array.isArray(stored)) ids = [...new Set(stored.map(String).filter((id) => /^\d+$/.test(id)))].slice(0, 4);
    } catch { /* Collection suggestions also work without browser history. */ }
    if (ids.length) {
      try {
        const url = new URL(this.dataset.searchUrl, location.origin);
        url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
        url.searchParams.set('type', 'product');
        url.searchParams.set('section_id', 'cart-recently-viewed');
        const response = await fetch(url, { signal: controller.signal });
        if (response.ok) {
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          cards = ids.map((id) => html.querySelector(`.cart-drawer__recently-viewed-card[data-product-id="${id}"]`)).filter(Boolean).slice(0, 3);
        }
      } catch { /* Fall back to the current cart product's collection. */ }
    }
    if (controller.signal.aborted || !this.isConnected) return;
    const recentCount = cards.length;
    const selectedIds = new Set(cards.map((card) => card.dataset.productId));
    const pool = [...(this.querySelector('[data-collection-fallback]')?.content.querySelectorAll('.cart-drawer__recently-viewed-card[data-product-id]') || [])]
      .filter((card) => !selectedIds.has(card.dataset.productId));
    for (let index = pool.length - 1; index > 0; index--) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [pool[index], pool[randomIndex]] = [pool[randomIndex], pool[index]];
    }
    cards.push(...pool.slice(0, 3 - cards.length).map((card) => card.cloneNode(true)));
    this.querySelector('[data-recently-viewed-list]').replaceChildren(...cards);
    const heading = this.querySelector('h2');
    if (heading) heading.textContent = recentCount ? 'Recently viewed' : 'You may also like';
    this.hidden = cards.length === 0;
  }
}
if (!customElements.get('cart-recently-viewed')) customElements.define('cart-recently-viewed', CartRecentlyViewed);

class CartPaymentOptions extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const button = this.querySelector('.cart__quick-payments-toggle');
    const panel = this.querySelector('[data-payment-options-panel]');
    if (!button || !panel) return;
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      this.toggleAttribute('data-open', open);
      panel.inert = !open;
      panel.setAttribute('aria-hidden', String(!open));
      // Reinitialize Shopify payment widgets after section replacements if supported.
      if (open) window.Shopify?.PaymentButton?.init?.();
    });
  }
}
if (!customElements.get('cart-payment-options')) customElements.define('cart-payment-options', CartPaymentOptions);
